import React from 'react'
import PropTypes from 'prop-types'

import { AppVerticalProvider } from '@cred/shared/AppVerticalContext'

import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import WidgetPage from 'components/hocs/widget-page'
import { getMetaQuery } from 'utils/data'
import useActiveLenders from 'components/hooks/useActiveLenders'
import { ADVERTISER_DISCLOSURE_THEMES } from 'common/constants'
import withApolloProvider from 'components/hocs/withApolloProvider'

import FullRateTableApp from './full-table/App'
import ShortenedRateTableApp from './shortened-table'
import { getFilteredLenders } from '../../utils/lenders'

const RateTableApp = (props) => {
  const {
    theme,
    variation,
    metaParams,
    verticals,
    type,
    showRateTableAsFirstPrequalStep,
    initialValues,
    widgetContext,
  } = props
  const { otherOptions } = widgetContext || {}

  const isFullTable = variation !== 'shortened'
  const showDisclosure = ADVERTISER_DISCLOSURE_THEMES.includes(theme)

  const metaQuery = getMetaQuery({ ...metaParams, marketplace: verticals, type }, theme)

  const fetchedLenders = useActiveLenders('personal')
  const availableLenders = getFilteredLenders({
    lenders: fetchedLenders,
    partnerPageUrl: initialValues?.options?.partnerPageUrl,
  })

  const rateTableProps = {
    ...props,
    availableLenders,
    theme,
    metaQuery,
    otherOptions,
  }

  const RateTable =
    isFullTable && !showRateTableAsFirstPrequalStep ? (
      <FullRateTableApp {...rateTableProps} />
    ) : (
      <ShortenedRateTableApp {...rateTableProps} shortened />
    )

  return (
    <AppVerticalProvider vertical="pl">
      {showDisclosure && <AdvertiserDisclosure tooltipId="fox-disclosure" theme={theme} />}
      <div>{RateTable}</div>
    </AppVerticalProvider>
  )
}

RateTableApp.propTypes = {
  theme: PropTypes.string,
  variation: PropTypes.string,
  metaParams: PropTypes.object,
  verticals: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.string,
  showRateTableAsFirstPrequalStep: PropTypes.bool,
  widgetContext: PropTypes.shape({
    otherOptions: PropTypes.arrayOf(PropTypes.string),
  }),
  initialValues: PropTypes.shape({
    options: PropTypes.shape({
      partnerPageUrl: PropTypes.string,
    }),
  }),
}

// Export named class and functions for unit tests
export { RateTableApp }

export default WidgetPage(withApolloProvider(RateTableApp))
